export function filterActiveProjects(projects) {
  return projects
    .filter((project) => {
      if (project.is_active !== true) {
        return false;
      }
      const statusName =
        typeof project.status === "string"
          ? project.status
          : project.status?.name;
      if (statusName === "Cancelled" || statusName === "Complete") {
        return false;
      }
      return true;
    })
    .sort((a, b) => a.name.localeCompare(b.name));
}

export function ensureProjectIncluded(projects, allProjects, projectId) {
  if (!projectId) {
    return projects;
  }

  const exists = projects.some(
    (project) => String(project.project_id) === String(projectId)
  );
  if (exists) {
    return projects;
  }

  const currentProject = allProjects.find(
    (project) => String(project.project_id) === String(projectId)
  );
  if (!currentProject) {
    return projects;
  }

  return [currentProject, ...projects].sort((a, b) =>
    a.name.localeCompare(b.name)
  );
}

export async function fetchProjectsForSelect(api, { currentProjectId } = {}) {
  const allProjects = await api.project.getProjects({
    _all: true,
    per_page: 100,
  });
  const activeProjects = filterActiveProjects(allProjects);
  return ensureProjectIncluded(activeProjects, allProjects, currentProjectId);
}
